<template>
  <div
    class="accordion"
    :class="props.theme"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="line"
    >
      <MoleculeAccordionItem
        ref="$items"
        v-bind="item"
        :as="as"
        :content="item.content"
        :theme="props.theme"
        @item:toggle="closeAllExceptTheOneWhoHasBeenClicked(index)"
      />
    </div>
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  as: {
    default() {
      return 'heading'
    },
    required: false,
    type: String,
    validator(value) {
      return ['heading', 'paragraph'].indexOf(value) !== -1
    },
  },
  items: {
    required: true,
    type: Array,
  },
  theme: {
    default() {
      return 'light'
    },
    required: false,
    type: String,
    validator(value) {
      return ['dark', 'light'].indexOf(value) !== -1
    },
  },
})

// Refs
const $items = ref(null)

// Methods
function closeAllExceptTheOneWhoHasBeenClicked(index) {
  $items.value.forEach((item, i) => {
    if (index !== i) {
      item.close()
    }
  })
}

// Expose
defineExpose({
  $items,
})
</script>

<style lang="postcss" scoped>
.accordion {
  @apply flex flex-col w-full;

  &.dark {
    .line {
      @apply border-white/20;
    }
  }

  &.light {
    .line {
      @apply border-grey-blue-200;
    }
  }

  .line {
    @apply flex flex-col w-full py-8 border-t-[0.25px];

    &:last-child {
      @apply border-b-[0.25px];
    }
  }
}
</style>
